export default __webpack_public_path__ + "static/media/4.921bfbe7.png";